// (c) chaehongee. Confidential and proprietary.

import type { CSSProperties, ReactElement, ReactNode } from 'react'
import { memo } from 'react'

interface CanvasViewportProps {
    className?: string
    contentScale: number
    contentOffset: { x: number; y: number }
    children?: ReactNode
}

export const CanvasViewport = memo(function CanvasViewport(props: CanvasViewportProps): ReactElement {
    const { className, contentScale, contentOffset, children } = props
    const style: CSSProperties = {
        transform: `translate(${contentOffset.x}px, ${contentOffset.y}px) scale(${contentScale})`,
        ['--content-scale' as any]: contentScale,
    }
    return (
        <div className={className} style={style}>{children}</div>
    )
})

